// extracted by mini-css-extract-plugin
module.exports = {"tabLabel":"TabLabel_tabLabel__271BK"};